/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect, lazy, useState } from "react";
import { connect } from "react-redux";
import { Badge, Col, Row, Table, Button } from "reactstrap";
import ReactTooltip from "react-tooltip";
import $ from "jquery";
import "smartmenus";
import { logout } from "../../../../reducers/authorization";
import { formatDate } from "../../../../utils/common";
import { withRouter, Link } from "react-router-dom";
import { updateRegisterState } from "../../../../reducers/register";
import {
  setBoolean,
  setFamilies,
  setCategories,
  getInventorySearchCriteria,
  clearFilters,
  setFilteredDates,
  setFilteredIDs,
} from "../../../../reducers/search";
import { push } from "react-router-redux";
// import moment from "moment";
import persistSearch from "../../../../utils/persistSearch";
import ConfirmationModal from "../../modal/confirmation-modal";

import {
  getHandoffToken,
  updateUserTermsAcceptance,
} from "../../../../reducers/auction";
import { updateTermsAcceptance } from "../../../../reducers/account";

import moment from "moment-timezone";
import { EventStatus } from "../../../../constants/event-status";
import LiveIcon from "../../../common/live-icon"

const SignOut = lazy(() => import("../../sign-out"));
const RegisterForm = lazy(() => import("../../../account/login"));

const EVENT_TYPES = {
  1: "Online",
  2: "OnSite",
  3: "ThirdParty",
};

const NavBar = (props) => {
  const {
    setFilteredIDs,
    persistSearch,
    clearFilters,
    setBoolean,
    setCategories,
    upcomingEvents = [],
    watchList,
    categories = [],
    comparedItems,
    isLoggedIn,
    username,
    firstname,
    isGuest,
    passwordRequest,
    error,
    logout,
    updateRegisterState,
    setIsNavEvent,
    isNavEvent,
    pathName,
    categoriesFilter,
    getInventory,
    clearAllParams,
    filteredIDs,
    location,
    push,
    content,
    isCurrentTermsAcceptance,
    updateUserTermsAcceptance,
    updateTermsAcceptance,
    userAccount,
    todaysEvents
  } = props;

  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [signOutModal, setSignOutModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [liveAuction, setLiveAuction] = useState(false);
  const [navClick, setNavClick] = useState(false);

  const [showTermsAcceptanceModal, toggleTermsAcceptanceModal] = useState(
    false
  );

  useEffect(() => {
    if (
      !userAccount.isGuest &&
      !userAccount.isCurrentTermsAcceptance &&
      pathName !== "/info-center"
    ) {
      toggleTermsAcceptanceModal((prevState) => !prevState);
    }
  }, [userAccount, isCurrentTermsAcceptance]);

  useEffect(() => {
    $(function () {
      $("#main-menu").smartmenus({
        noMouseOver: true,
        subMenusSubOffsetX: 1,
        subMenusSubOffsetY: -8,
      });
    });
  }, [isGuest]);

  useEffect(() => {
    const handleLogin = () => {
      setRegisterModalOpen(true);
    };

    const params = new URLSearchParams(window.location.search);
    const createParam = params.get("create");

    if (
      (isGuest && pathName === "/register") ||
      (isGuest && pathName === "/account") ||
      createParam === "true"
    ) {
      setIsNavEvent({ isNavEvent: true });
      handleLogin();
    }
  }, [pathName]);

  const handleClick = () => {
    var closemyslide = document.getElementById("main-menu");
    var hasOverlay = document.getElementById("main-nav");

    closemyslide && closemyslide.classList.remove("open-menu");
    hasOverlay && hasOverlay.classList.remove("hasOverlay");
  };

  const openNav = () => {
    var hasOverlay = document.getElementById("main-nav");
    var openmyslide = document.getElementById("main-menu");

    if (openmyslide && hasOverlay) {
      openmyslide.classList.add("open-menu");
      hasOverlay.classList.add("hasOverlay");
    }
  };

  const closeNav = () => {
    var hasOverlay = document.getElementById("main-nav");
    var openmyslide = document.getElementById("main-menu");

    if (openmyslide && hasOverlay) {
      openmyslide.classList.remove("open-menu");
      hasOverlay.classList.remove("hasOverlay");
    }
  };

  const handleSignUpClick = () => {
    if (passwordRequest || error !== "") {
      updateRegisterState({ passwordRequest: false, error: "" });
    }
    let promise = new Promise((resolve) => {
      resolve(setIsNavEvent({ isNavEvent: true }));
    });
    promise.then(() => {
      setRegisterModalOpen(!registerModalOpen);
    });
  };

  const handleTermsAcceptanceClick = async () => {
    await updateUserTermsAcceptance({ event_ID: 0 }, (result) => {
      toggleTermsAcceptanceModal((prevState) => !prevState);
      updateTermsAcceptance(result);
    });

    // console.log("updateUserTermsAcceptance page =>", result);

    // if (result) toggleTermsAcceptanceModal((prevState) => !prevState);
  };

  const handleCancelTermsAcceptanceClick = async () => {
    await logout();
    window.location.reload();
  };

  const handleLogoutModal = () => {
    setSignOutModal(!signOutModal);
  };

  useEffect(() => {
    const fetchData = async () => {
      await getInventory({
        categories: categoriesFilter.join("|"),
        // auctionDates: filteredDates.join("|"),
        event_ids: filteredIDs.join("|"),
        page_number: 1,
      }).then(() => {
        setNavClick(false);
      });
    };
    if (navClick) {
      fetchData();
    }
  }, [navClick]);

  const handleCategoryNav = (item) => {
    if (item.id === 0) {
      Promise.all([clearFilters(), push("/search")]);
    } else {
      Promise.all([
        clearAllParams(),
        clearFilters(),
        setCategories(item.id),
        setBoolean({ id: item.id, isChecked: true }),
        persistSearch({ page_number: "1" }, "page_number"),
        persistSearch({ categories: item.value }, "categories"),
        location.pathname.includes("/search") && setNavClick(true),
      ]);
    }
  };

  const handViewAuctionItems = (event) => {
    if (event.isThirdParty) {
      push("/upcoming-auctions");
      setNavClick(true);
      $.SmartMenus.hideAll();
    } else {
      // const formatData = moment(event.date).format("ddd, MMM DD, YYYY");
      Promise.all([
        clearAllParams(),
        clearFilters(),
        // setFilteredDates(formatData),
        setFilteredIDs(event.event_ID.toString()),
        setBoolean({ event_ID: event.event_ID.toString(), isChecked: true }),
        persistSearch({ page_number: "1" }, "page_number"),
        persistSearch({ events: event.event_ID.toString() }, "events"),
        location.pathname.includes("/search") && setNavClick(true),
      ]);
      $.SmartMenus.hideAll();
    }
  };

  const renderUpcommingEvents = upcomingEvents.map((event) => (
    <div key={event.event_ID} className="link-section">
      <div className="menu-title">
        <h5>{event.eventName}</h5>
      </div>
      <div className="menu-content">
        <ul>
          <li onClick={() => handleClick()}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="pointer underline"
              onClick={() => handViewAuctionItems(event)}
            >
              {formatDate(event.eventDateTime)}
            </a>
          </li>
        </ul>
      </div>
    </div>
  ));

  // eslint-disable-next-line no-unused-vars
  const renderMobileNavCat =
    categories &&
    Object.entries(categories).map(([key, obj]) => {
      return (
        <div className="link-section" key={obj.id}>
          <div className="menu-content">
            <ul>
              <li onClick={() => handleClick()}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => handleCategoryNav(obj)}>{obj.value}</a>
              </li>
            </ul>
          </div>
        </div>
      );
    });

  const topNavItems =
    content &&
    content.links.map((obj) => (
      <li
        key={obj.sequence}
        onClick={() => handleClick()}
        className="mega d-xl-none"
      >
        <Link className="has-submenu underline" to={`/content?${obj.key}`}>
          {obj.value}
        </Link>
      </li>
    ));

  return (
    <div>
      <ReactTooltip place="top" type="dark" effect="float" />
      <nav id="main-nav">
        <div className="sidebar-overlay" />
        <div className="toggle-nav" onClick={() => openNav()}>
          <i className="fa fa-bars sidebar-bar"></i>
        </div>
        <ul id="main-menu" className="sm pixelstrap sm-horizontal">
          <li>
            <div className="mobile-back text-right" onClick={() => closeNav()}>
              Back<i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
            </div>
          </li>
          <li className="mega">
            <a
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <i className="fa fa-th-large" /> Inventory
            </a>
            <ul className="mega-menu full-mega-menu">
              <div className="row display-none d-xl-block">
                <div className="col">
                  <h5 style={{ fontSize: "20px" }}>Categories</h5>
                </div>
              </div>
              <div className="dropdown-divider display-none d-xl-block"></div>
              <div className="category-nav-container">
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={10}
                  className="block-nav"
                >
                  <Row>
                    <li className="col-sx-12 col-sm-12 col-md-12 col-xl-3 pointer mr-3">
                      <a
                        onClick={() =>
                          handleCategoryNav({ id: 0, value: "All" })
                        }
                      >
                        All
                      </a>
                    </li>
                    {/* eslint-disable-next-line no-unused-vars */}
                    {categories &&
                      Object.entries(categories).map(([key, obj]) => {
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        return (
                          <li
                            key={obj.id}
                            className="col-sx-12 col-sm-12 col-md-12 col-xl-3 pointer mr-3"
                            style={{whiteSpace: 'normal',  overflowWrap:'break-word'}}
                          >
                            <a onClick={() => handleCategoryNav(obj)}>
                              {obj.value}
                            </a>
                          </li>
                        );
                      })}
                  </Row>
                </Col>
              </div>
              <div className="cat-nav d-lg-block d-xl-none">
                <div className="col mega-box">
                  {renderMobileNavCat}
                  <div className="link-section d-lg-block d-xl-none">
                    <div className="menu-content">
                      <ul>
                        <li onClick={() => handleClick()}>
                          <Link to="/search">View All Inventory</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </li>
          <li
            className="account-nav-dropdown mega"
          // onClick={isGuest ? () => handleClick() : null}
          >
            <Link to="/upcoming-auctions" className="pointer has-submenu">
              <div className="d-flex align-items-center">
                {upcomingEvents.some(event => event.eventStatus_ID === EventStatus.InProgress) || todaysEvents.some(event => event.eventStatus_ID === EventStatus.InProgress) ? (
                    <LiveIcon style={{height: '15px'}}/>
                ) : <i className={"fa fa-gavel"} />}
                <div className="ml-1">Auctions</div>
              </div>
            </Link>
          </li>
          {/* <li className="mega"> */}
          {/* <li style={{color: "#FFFFFF !important"}}> */}
          {/* <Link style={{color: "#FFFFFF !important"}} to="/upcoming-auctions">
              <i className="fa fa-gavel" /> Auctions
            </Link> */}
          {/* <ul className="mega-menu full-mega-menu">
              <li>
                <div className="container">
                  {liveAuction && (
                    <div
                      className="row dark-blue-bg"
                      style={{ marginBottom: "10px" }}
                    >
                      <div className="col-lg-12 form-inline">
                        <div className="col-md-12 col-xl-3">
                          <h5 className="h5-inverse">
                            Online Auction Tuesday May 21<sup>st</sup>
                          </h5>
                        </div>
                        <div className="col-md-12 col-xl-2">
                          <div className="liveContainer">
                            <div className="liveIcon"></div>
                            <span className="liveText">Live Now</span>
                          </div>
                        </div>
                        <div className="col-md-12 col-xl-7 live-btn-wrapper">
                          <Link
                            style={{ maxWidth: "200px" }}
                            to="/live-auction"
                            className="btn btn-white btn-padded"
                          >
                            Enter Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col">
                      <h5
                        className="display-none d-xl-block"
                        style={{ fontSize: "20px" }}
                      >
                        Upcoming Auctions
                      </h5>
                    </div>
                  </div>
                  <div className="row display-none d-xl-block">
                    <div className="col">
                      <Table striped borderless>
                        <thead>
                          <tr>
                            <th className="text-center">Date</th>
                            <th>Time</th>
                            <th>Timezone</th>
                            <th>Type</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {upcomingEvents.map((x) => (
                            <tr key={x.event_ID} style={{ cursor: "pointer" }}>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                align="center"
                                style={{
                                  width: "15%",
                                  verticalAlign: "middle",
                                }}
                              >
                                <i className="fa fa-calendar"></i>
                                <br />
                                {moment
                                  .utc(x.eventDateTime)
                                  .local()
                                  .format("DD MMMM")}
                              </td>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                style={{ verticalAlign: "middle" }}
                              >
                                {moment
                                  .utc(x.eventDateTime)
                                  .local()
                                  .format("h:mm A")}
                              </td>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                style={{ verticalAlign: "middle" }}
                              >
                                {moment.tz(moment.tz.guess()).zoneAbbr()}
                              </td>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                style={{ verticalAlign: "middle" }}
                              >
                                {x.eventType}
                              </td>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                style={{ verticalAlign: "middle" }}
                              >
                                {x.eventName}
                              </td>
                              <td
                                onClick={() => handViewAuctionItems(x)}
                                style={{ verticalAlign: "middle" }}
                              >
                                {x.eventDescription}
                              </td>
                              <td>
                                
                                {x.eventType === "Online" && x.live && (
                                  <Button
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      $.SmartMenus.hideAll();
                                      push("/live-auction");
                                    }}
                                    className="btn btn-secondary btn-block"
                                  >
                                    <span>ENTER AUCTION</span>
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="cat-nav d-lg-block d-xl-none">
                    <div className="col mega-box">
                      {renderUpcommingEvents}
                      <div className="link-section d-lg-block d-xl-none">
                        <div className="menu-content">
                          <ul>
                            <li onClick={() => handleClick()}>
                              <Link to="/upcoming-auctions">
                                Upcoming Auctions
                              </Link>
                            </li>
                            <li onClick={() => handleClick()}>
                              <Link to="/past-auctions">Past Auctions</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-divider display-none d-xl-block"></div>
                  <div className="row display-none d-xl-block">
                    <div className="col mega-box justify-content-between">
                      <div className="link-section form-inline">
                        <ul>
                          <li onClick={() => handleClick()}>
                            <Link to="/upcoming-auctions">
                              Upcoming Auctions
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div
                        className="link-section form-inline mr-0"
                        style={{ width: 94 }}
                      >
                        <ul>
                          <li onClick={() => handleClick()}>
                            <Link to="/past-auctions">Past Auctions</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul> */}
          {/* </li> */}
          {/* {isLoggedIn &&
                            <li>
                                <Link to="/cart"><i className="fa fa-shopping-cart" /> My Cart <sup><Badge color="primary">{cartItems.length}</Badge></sup></Link>
                            </li>
                        } */}
          {isLoggedIn && watchList.length > 0 && (
            <li onClick={() => handleClick()} className="mega">
              <Link to="/myaccount?watchlist" className="has-submenu">
                <i className="fa fa-eye" /> Watchlist{" "}
                <sup>
                  <Badge color="primary">{watchList.length}</Badge>
                </sup>
              </Link>
            </li>
          )}
          {isLoggedIn && comparedItems.length > 0 && (
            <li onClick={() => handleClick()} className="mega">
              <Link to="/compare" className="has-submenu">
                <i className="fa fa-star" /> Compared List{" "}
                <sup>
                  <Badge color="primary">{comparedItems.length}</Badge>
                </sup>
              </Link>
            </li>
          )}
          {topNavItems}
          <li onClick={() => handleClick()} className="mega d-xl-none">
            <Link className="has-submenu underline" to={`/info-center`}>
              Information
            </Link>
          </li>
          <li
            className="account-nav-dropdown mega"
            onClick={isGuest ? () => handleClick() : null}
          >
            <a
              className="pointer has-submenu"
              onClick={!isGuest ? null : () => handleSignUpClick()}
            >
              <i className={isGuest ? "fa fa-sign-in" : "fa fa-user"} />
              &nbsp;
              {isGuest ? "Sign In/Register" : firstname || username}
            </a>
            {!isGuest && username !== undefined ? (
              <ul className="small-dropdown-menu">
                <React.Fragment>
                  <li onClick={() => handleClick()}>
                    <Link to="/myaccount">My Account</Link>
                  </li>
                  <li onClick={() => handleClick()}>
                    <a onClick={() => handleLogoutModal()}>Sign Out</a>
                  </li>
                </React.Fragment>
              </ul>
            ) : null}
          </li>
        </ul>
      </nav>
      {registerModalOpen ? (
        <RegisterForm
          {...{
            isNavEvent,
            setIsNavEvent,
            passwordRequest,
          }}
          toggle={() => handleSignUpClick()}
          isOpen={registerModalOpen}
        />
      ) : null}
      {Boolean(showTermsAcceptanceModal) && isLoggedIn && (
        <ConfirmationModal
          showModal={showTermsAcceptanceModal}
          turnModal={toggleTermsAcceptanceModal}
          onSubmit={handleTermsAcceptanceClick}
          handleCancelSubmit={handleCancelTermsAcceptanceClick}
          header={"Accept General Terms and Conditions"}
          text={`The General Terms and Conditions have changed. Please read the new version and accept to continue or you will not be able to log into your account.`}
          terms={content.generalTermsAndConditionsDocument}
        />
      )}
      {signOutModal ? (
        <SignOut
          toggle={() => handleLogoutModal()}
          isOpen={signOutModal}
          logout={logout}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.authorization.status,
  username: state.authorization.userName,
  firstname: state.userAccount.firstName,
  upcomingEvents: state.events.upcomingEvents,
  watchList: state.watchList.watchListItems,
  cartItems: state.cart.cartItems,
  isGuest: state.authorization.isGuest,
  categories: state.main.categories,
  passwordRequest: state.register.passwordRequest,
  error: state.register.error,
  searchCategories: state.search.categories,
  comparedItems: state.compare.comparedItems,
  pathName: state.router.location.pathname,
  filteredDates: state.search.filteredDates,
  filteredIDs: state.search.filteredIDs,
  content: state.authorization.content,
  isCurrentTermsAcceptance: state.userAccount.isCurrentTermsAcceptance,
  userAccount: state.userAccount,
  todaysEvents: state.events.todaysEvents,
});

const mapDispatchToProps = {
  logout,
  updateRegisterState,
  setFamilies,
  setBoolean,
  setCategories,
  getInventorySearchCriteria,
  push,
  clearFilters,
  setFilteredDates,
  setFilteredIDs,
  persistSearch,
  getHandoffToken,
  updateUserTermsAcceptance,
  updateTermsAcceptance,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar));
